import { useEffect, useState } from 'react'

export default function useLoading(
  handleAbove: any,
  pages: any,
): [boolean, number] {
  const [arePagesLoaded, setarePagesLoaded] = useState(false)
  const [isFirst, setisFirst] = useState(true)
  const duration = (pages.length + 1) * 0.55
  useEffect(() => {
    if (isFirst) {
      setisFirst(false)
      for (let i = 0; i <= pages.length; i++) {
        setTimeout(() => {
          handleAbove(pages[i])
        }, (i + 1) * 550)
        if (i === pages.length) {
          setTimeout(() => {
            setarePagesLoaded(true)
          }, (i + 2) * 550)
        }
      }
    }
  }, [isFirst, handleAbove])
  return [arePagesLoaded, duration]
}
